import { render, staticRenderFns } from "./SchoolAttributeFilters.vue?vue&type=template&id=b6b913fa&"
import script from "./SchoolAttributeFilters.vue?vue&type=script&lang=js&"
export * from "./SchoolAttributeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lee/Developer/Auris/admin-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b913fa')) {
      api.createRecord('b6b913fa', component.options)
    } else {
      api.reload('b6b913fa', component.options)
    }
    module.hot.accept("./SchoolAttributeFilters.vue?vue&type=template&id=b6b913fa&", function () {
      api.rerender('b6b913fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SchoolAttributeFilters.vue"
export default component.exports